// import '../../mock/discoverydata.js'
// import request from '@/utils/request'
import {selfRequest_index,selfRequest_224,selfRequest_235,selfRequest_getSchoolDetail,selfRequest_getUniList} from '@/utils/selfRequest'
// import selfRequest_hoge from '@/utils/selfRequest'


export function selfRequest_idx(parameter) {
  return selfRequest_index(parameter)
}

export function selfRequest_gsd(parameter) {
  return selfRequest_getSchoolDetail(parameter)
}
// export function getDiscovery() {
//   // return selfRequest(parameter, topicApi.topicList)
//   return request({
//     url: '/getdiscovery',
//     method: 'post'
//   })
// }

export function selfRequest_gul(parameter) {
  return selfRequest_getUniList(parameter)
}

export function selfRequest224(parameter) {
  return selfRequest_224(parameter)
}

export function selfRequest235(parameter) {
  return selfRequest_235(parameter)
}